import Vue from 'vue'
import Router from 'vue-router'
import home from '@/views/web/home'
import deptIntroduction from '@/views/web/deptIntroduction'
import corporateCulture from '@/views/web/corporateCulture'
import socialRecruitment from '@/views/web/socialRecruitment'
import schoolEnrollment from '@/views/web/schoolEnrollment'
import activityInformation from '@/views/web/activityInformation'
import learnMore from '@/views/web/learnMore'

Vue.use(Router)

export default new Router({
  routes: [
    { //首页
      path: '/',
      name: 'Home',
      component: home
    },
    { //部门介绍
      path: '/deptIntroduction',
      name: 'DeptIntroduction',
      component: deptIntroduction
    },
    { //企业文化、员工故事
      path: '/corporateCulture',
      name: 'CorporateCulture',
      component: corporateCulture
    },
    { //社招
      path: '/socialRecruitment',
      name: 'SocialRecruitment',
      component: socialRecruitment
    },
    { //校招
      path: '/schoolEnrollment',
      name: 'SchoolEnrollment',
      component: schoolEnrollment
    },
    { //活动信息
      path: '/activityInformation',
      name: 'ActivityInformation',
      component: activityInformation
    },
    { //活动信息
      path: '/learnMore',
      name: 'learnMore',
      component: learnMore
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js